import { memo } from "react";

import { Box, Checkbox, Tooltip, Typography } from "@material-ui/core";

import themeColorsDesingSystem from "assets/theme/ds-colors";

import { formatRepresentativeLabel } from "../utils/representative-helpers";

function RepresentativeCard({ item, checked, onChange, disabled }) {
  const isUnavailable = item?.Disponivel === false;
  const tooltipTitle = isUnavailable
    ? item?.PublicadoPeloRepresentanteAtual
      ? "Você já publicou este cliente"
      : `Já publicado por ${item?.RepresentanteQuePublicou || "outro representante"}`
    : "";

  const row = (
    <Box
      display="flex"
      alignItems="center"
      py={1}
      px={1}
      style={{
        borderBottom: `1px solid ${themeColorsDesingSystem.stone.light}`,
        opacity: isUnavailable ? 0.6 : 1,
      }}
    >
      <Checkbox
        checked={checked}
        onChange={onChange}
        disabled={disabled || isUnavailable}
        color="primary"
        size="small"
      />
      <Typography
        variant="body2"
        style={{
          margin: 0,
          color: themeColorsDesingSystem.text.primary,
          fontSize: "0.875rem",
          lineHeight: 1.4,
        }}
      >
        {formatRepresentativeLabel(item)}
      </Typography>
    </Box>
  );

  return isUnavailable ? (
    <Tooltip title={tooltipTitle} arrow placement="top-start">
      <span>{row}</span>
    </Tooltip>
  ) : (
    row
  );
}

export default memo(RepresentativeCard);
